import { render } from "./modals.vue?vue&type=template&id=d8b5ff52"
import script from "./modals.vue?vue&type=script&lang=js"
export * from "./modals.vue?vue&type=script&lang=js"

import "./modals.vue?vue&type=style&index=0&id=d8b5ff52&lang=css"

import exportComponent from "/home/eymekkjd/staging.infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__